export class AlertItemUser {
    readonly userId: number;
    readonly first: string;
    readonly last: string;

    constructor(options: {
        userId: number;
        first: string;
        last: string;
    }) {
        this.userId = options.userId;
        this.first = options.first;
        this.last = options.last;
    }
}
